import React, { useEffect, useContext } from 'react';

import { ToastContainer } from 'react-toastify';
import { Navbar, Footer, Sidebar } from '../../../components';
import { useStateContext } from '../../../context/ContextProvider';

import BlogContext from '../../../context/blog/blogContext';

import PostDetail from './PostDetail';
import 'react-toastify/dist/ReactToastify.css';

const Blogs = () => {
  const { setCurrentColor, setCurrentMode, currentMode, activeMenu } = useStateContext();
  const blogContext = useContext(BlogContext);
  const { getPrivateBlogs, privateBlogs } = blogContext;

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);


  useEffect(() => {
    getPrivateBlogs();
  }, []);


  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <div className="flex relative  dark:bg-main-dark-bg">

        {activeMenu ? (
          <div className="w-52 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
        <div
          className={
                        activeMenu
                          ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-52 w-full  '
                          : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
                    }
        >
          <div className="fixed h-12 md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
            <Navbar />
          </div>

          <PostDetail privateBlogs={privateBlogs} />
          <Footer />
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>

  );
};
export default Blogs;
